// extracted by mini-css-extract-plugin
export default {"p1":"style_p1__A203W"};